import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import * as Actions from 'flex/Actions';
import { useAppSelector } from 'flex/utils';

type CallbackFn = (meta: unknown, payload: unknown, isControl: boolean) => void

type OrganizationState = {
    isLoading: boolean
    list: Organization[]
}

const useOrganization = (
    // ここでは引数は使わないが、他でここの実装を真似する際のためにそれっぽくしておく
    successCallback: CallbackFn = () => undefined,
    failureCallback: CallbackFn = () => undefined,
) => {
    const dispatch = useDispatch();
    const [state, setState] = useState<OrganizationState>({
        isLoading: false,
        list: [],
    });

    const questionnaireControlTargetOrganizationConnection = useAppSelector(state => state.questionnaireControlTargetOrganizationConnection);

    useEffect(() => {
        const { meta, payload } = questionnaireControlTargetOrganizationConnection;

        // 通信中でない === 画面遷移など意図しないタイミング
        if (!state.isLoading) return;

        switch (meta.status) {
            case Actions.statusEnum.SUCCESS: {
                successCallback(meta, payload, true);
                setState(state => ({
                    ...state,
                    isLoading: false,
                    list: payload.result.items,
                }));
                return;
            }
            case Actions.statusEnum.FAILURE:
            case Actions.statusEnum.ERROR: {
                failureCallback(meta, payload, true);
                setState(state => ({
                    ...state,
                    isLoading: false,
                }));
                return;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [questionnaireControlTargetOrganizationConnection]);

    const request = useCallback((
        uuid: string
    ) => {

        dispatch(Actions.http.connection.questionnaires.controlTargetOrganization(uuid));
        setState(state => ({
            ...state,
            isLoading: true,
        }));

    }, [dispatch]);

    const reset = useCallback(() => {
        setState({
            isLoading: false,
            list: [],
        });
    }, []);

    return [state, request, reset] as const;
};

export default useOrganization;
